module.exports = __webpack_public_path__ + "img/border4.c118b64f.png";